import {
  scroller
} from 'react-scroll'
import {
  call,
  takeEvery,
  take,
  select,
  put,
  fork,
  all,
} from 'redux-saga/effects'
import T from 'i18n-react'

import {
  UPDATE_PROJECT_SUCCESS,
  POST_UPDATE_PROJECT_ERROR,
  POST_PROJECT_REVISION_ERROR
} from 'containers/Project/constants'
import {
  DISPATCH_VALIDATE_FORM_SUCCESS,
} from 'containers/Form/Validation/constants'
import {
  invalidCategorySelector as invalidSelector,
} from 'containers/Form/Validation/selectors'
import {
  categoryElementsSelector
} from 'containers/Form/Project/selectors'
import {
  postUpdateProject,
  setFormStatus
} from 'containers/Project/actions'
import {
  updateRedirect
} from './actions'
import {
  FORM_STATUS,
} from 'containers/Project/constants'
import {
  error
} from 'containers/App/Notification/actions'
import {
  projectScheduleChangeValidSelector
} from 'containers/Project/ScheduleSection/selectors'

const invalidCategorySelector = invalidSelector(categoryElementsSelector)

function* watchUpdateProject() {
  const action = yield take([
    POST_UPDATE_PROJECT_ERROR,
    POST_PROJECT_REVISION_ERROR,
    UPDATE_PROJECT_SUCCESS
  ])
  if (action.type === UPDATE_PROJECT_SUCCESS) {
    yield put(setFormStatus(FORM_STATUS.REVIEW))
    yield put(updateRedirect(true))
  }
}

function* validateFormSuccess() {
  const invalidCategory = yield select(invalidCategorySelector)
  const invalidSchedule = !(yield select(projectScheduleChangeValidSelector))
  if (invalidCategory) {
    scroller.scrollTo(invalidCategory, {
      duration: 500,
      smooth: true,
      containerId: 'mainContainer',
    })
    yield put(error(T.translate('pages.project.overview.notification.incomplete')))
  } else if (invalidSchedule) {
    scroller.scrollTo('Schedule', {
      duration: 500,
      smooth: true,
      containerId: 'mainContainer',
    })
    yield put(error(T.translate('pages.project.overview.notification.schedule_error')))
  } else {
    const {
      projectOverview: {
        projectId,
        workflowId
      }
    } = yield select()
    yield put(postUpdateProject(projectId, workflowId, true))
    yield fork(watchUpdateProject)
  }
}

function* watchValidateFormSuccess() {
  yield takeEvery(DISPATCH_VALIDATE_FORM_SUCCESS, validateFormSuccess)
}

function* loadSagas() {
  yield all([
    fork(watchValidateFormSuccess),
  ])
}

export default loadSagas
